import { ArchiveMinusIcon, CrownOutIcon, HeadPhoneIcon, WalletIcon } from '@insta-club/components/icons';
import { useSessionStore } from '@insta-club/state';
import { t } from '@insta-club/translations';
import { FancyLink } from '@insta-club/ui';
import { cva } from 'class-variance-authority';
import { pushToDataLayer } from 'src/libs/utilities/analytics';

interface Props {
    title: string;
    href: string;
    icon: React.ReactElement;
    variant: 'wallet' | 'subscription' | 'support' | 'favorite';
    hasNotice?: boolean;
    onClick?: () => void;
}

const containerVariants = cva(
    'flex flex-1 flex-col items-center justify-center gap-2.5 rounded-2xl px-2 py-4 relative',
    {
        variants: {
            variant: {
                wallet: 'bg-success-50 text-success-500',
                subscription: 'bg-secondary-50 text-secondary-500',
                support: 'bg-primary-50 text-primary-600',
                favorite: 'bg-warning-50 text-warning-800'
            }
        }
    }
);

const QuickAccess: React.FC<Props> = ({ title, icon, variant, href, hasNotice, onClick }) => {
    return (
        <FancyLink onClick={onClick} href={href} className={containerVariants({ variant })}>
            {hasNotice && (
                <i className='bg-danger-500 absolute top-0 right-0 h-3 w-3 rounded-full border-2 border-white'></i>
            )}
            {icon}
            <span className='bg-blue text-sm font-semibold text-nowrap'>{title}</span>
        </FancyLink>
    );
};

export const MainQuickAccess = () => {
    const unreadTickets = useSessionStore((state) => state.session?.unread_tickets);
    const userID = useSessionStore((state) => state.session?.id);

    return (
        <div className='flex flex-wrap items-center gap-2 sm:gap-4'>
            <QuickAccess
                onClick={() => {
                    pushToDataLayer({
                        event: 'feature_click',
                        event_name: 'feature_click',
                        feature_name: 'subscription',
                        user_id: userID,
                        source_screen: 'dashboard'
                    });
                }}
                variant='subscription'
                href='/subscription'
                title={t('subscription')}
                icon={<CrownOutIcon />}
            />
            <QuickAccess
                onClick={() => {
                    pushToDataLayer({
                        event: 'feature_click',
                        event_name: 'feature_click',
                        feature_name: 'support',
                        user_id: userID,
                        source_screen: 'dashboard'
                    });
                }}
                variant='support'
                href='/support'
                title={t('support')}
                icon={<HeadPhoneIcon />}
                hasNotice={!!unreadTickets}
            />
            <QuickAccess
                onClick={() => {
                    pushToDataLayer({
                        event: 'feature_click',
                        event_name: 'feature_click',
                        feature_name: 'wallet',
                        user_id: userID,
                        source_screen: 'dashboard'
                    });
                }}
                variant='wallet'
                href='/wallet'
                title={t('wallet')}
                icon={<WalletIcon />}
            />
            <QuickAccess
                onClick={() => {
                    pushToDataLayer({
                        event: 'feature_click',
                        event_name: 'feature_click',
                        feature_name: 'favorite',
                        user_id: userID,
                        source_screen: 'dashboard'
                    });
                }}
                variant='favorite'
                href='/profile/favorite'
                title={t('favorite')}
                icon={<ArchiveMinusIcon />}
            />
        </div>
    );
};

export default QuickAccess;

